/**
 * Animated aurora background — pure CSS, GPU-friendly.
 * Drop into a `relative` container; sits behind content via z-index.
 */
export const Aurora = ({
  className = "",
  intensity = "default", // "default" | "subtle" | "intense"
}) => {
  const opacityMap = { subtle: 0.4, default: 0.7, intense: 1 };
  const o = opacityMap[intensity] ?? 0.7;
  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      style={{ opacity: o }}
      aria-hidden="true"
    >
      <div className="absolute -top-32 -left-24 w-[520px] h-[520px] rounded-full bg-[#29ABE2]/30 blur-3xl animate-aurora-a" />
      <div className="absolute top-1/4 -right-32 w-[460px] h-[460px] rounded-full bg-[#0a6fc2]/25 blur-3xl animate-aurora-b" />
      <div className="absolute -bottom-32 left-1/4 w-[420px] h-[420px] rounded-full bg-[#1d4ed8]/25 blur-3xl animate-aurora-c" />
    </div>
  );
};
